import * as Constantes from '../../../shared/constants';

import { Component, OnInit, OnDestroy } from '@angular/core';
import { InfoService } from 'src/app/services/info.service';
import { InactividadService } from 'src/app/services/inactividad.service';
import { VERSION } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent implements OnInit, OnDestroy {
  public environment = environment;
  loading: boolean = false;
  info: string = '';
  angularVersion = VERSION.full; // Recupera la versión completa de Angular
  localTime: Date = new Date();
  public tiempoRestante: number = 0;
  private timerCountdown: any;

  serverTime: any = {};


  // Usar cantantes en el template
  Constantes = Constantes;

  constructor(
    private infoSrv: InfoService,
    private inactividadSrv: InactividadService
  ) { }

  ngOnInit(): void {
    this.getSetverInfo(); // Changed from listaInfo to getSetverInfo to match existing method
    this.getServerTime();

    // Actualizar cada segundo
    this.timerCountdown = setInterval(() => {
      this.localTime = new Date();
      this.tiempoRestante = this.inactividadSrv.getRemainingTime();
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.timerCountdown) {
      clearInterval(this.timerCountdown);
    }
  }

  getSetverInfo() {
    this.loading = true;
    this.infoSrv.getInfo().subscribe(resp => {
      this.loading = false;
      this.info = resp;
    });
  }
  getServerTime() {
    this.loading = true;
    this.infoSrv.getServerTime().subscribe(resp => {
      this.loading = false;
      this.serverTime = resp;
    });
  }
}
